import * as React from 'react';
import App from './App';
const LoginSSO = () => {
    return (
            <App />
    );
};

export default LoginSSO;
